import Box from '@mui/material/Box';
import MuiDialog from '@mui/material/Dialog';
import { PaperProps } from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { theme } from '../../services/theme';
import { CloseIcon } from '../icons';

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  sx?: PaperProps['sx'];
  title?: string;
  withCloseIcon?: boolean;
}

export const Dialog: FC<Props> = ({
  children,
  isOpen,
  onClose,
  title,
  sx,
  withCloseIcon = true,
}) => (
  <MuiDialog
    disableScrollLock
    BackdropProps={{ sx: { backgroundColor: 'transparent' } }}
    PaperProps={{
      sx: {
        backgroundColor: '#F1F6F9',
        borderRadius: '12px',
        boxShadow: '-1px 1px 2px rgba(0, 0, 0, 0.25)',
        height: '270px',
        padding: '30px',
        width: '540px',
        [theme.breakpoints.down('sm')]: {
          height: '250px',
          padding: '20px',
          width: '400px',
          borderRadius: '10px',
        },
        [theme.breakpoints.down('mobile')]: {
          height: '250px',
          padding: '15px 5px 5px',
          width: '320px',
          borderRadius: '8px',
        },
        ...sx,
      },
    }}
    onBackdropClick={onClose}
    open={isOpen}
  >
    {title ? (
      <Typography
        fontWeight="regular"
        sx={{
          color: '#260F26',
          fontSize: '24px',
          lineHeight: '34px',
          marginBottom: '12px',
          textAlign: 'center',
          [theme.breakpoints.down('sm')]: {
            fontSize: '20px',
            lineHeight: '22px',
          },
          [theme.breakpoints.down('mobile')]: {
            fontSize: '16px',
            lineHeight: '18px',
          },
        }}
      >
        {title}
      </Typography>
    ) : null}
    {children}
    {withCloseIcon ? (
      <Box
        onClick={onClose}
        sx={{
          cursor: 'pointer',
          m: 0,
          padding: '15px 10px',
          position: 'absolute',
          right: 0,
          top: 0,
          [theme.breakpoints.down('sm')]: {
            padding: '10px 7px',
          },
        }}
      >
        <CloseIcon
          sx={{
            color: '#9AB1C0',
            cursor: 'pointer',
            fontSize: '20px',
            [theme.breakpoints.down('sm')]: {
              fontSize: '17px',
            },
            [theme.breakpoints.down('mobile')]: {
              fontSize: '15px',
            },
          }}
        />
      </Box>
    ) : null}
  </MuiDialog>
);
